import { useState } from "react";
import { KeyRound, Mail } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ComingSoon({ onUnlock }) {
  const [showCode, setShowCode] = useState(false);
  const [code, setCode] = useState("");
  const [codeMsg, setCodeMsg] = useState(null);
  const [codeBusy, setCodeBusy] = useState(false);
  const [email, setEmail] = useState("");
  const [wlState, setWlState] = useState("idle");
  const [wlMsg, setWlMsg] = useState("");

  const submitCode = async (e) => {
    e.preventDefault();
    if (codeBusy) return;
    setCodeBusy(true);
    setCodeMsg(null);
    try {
      const res = await fetch(`${API}/api/access-code/validate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.valid) {
        try {
          localStorage.setItem("tapin-unlocked", "1");
        } catch (err) {}
        onUnlock();
      } else {
        setCodeMsg({ ok: false, text: data.detail || "That code isn't valid. Check it and try again." });
      }
    } catch (err) {
      setCodeMsg({ ok: false, text: "Something went wrong. Try again." });
    } finally {
      setCodeBusy(false);
    }
  };

  const submitWaitlist = async (e) => {
    e.preventDefault();
    if (wlState === "busy") return;
    setWlState("busy");
    try {
      const res = await fetch(`${API}/api/waitlist`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        setWlMsg(
          data.duplicate
            ? "You're already on the list — see you at launch."
            : `You're #${data.position} on the list — see you at launch.`
        );
        setWlState("done");
      } else {
        setWlMsg("That email didn't work. Check it and try again.");
        setWlState("error");
      }
    } catch (err) {
      setWlMsg("Something went wrong. Try again.");
      setWlState("error");
    }
  };

  return (
    <div className="wall" data-testid="coming-soon-wall">
      <main className="wall-center">
        <div className="wall-halo">
          <img src="/brand/logo-circle.png" alt="Tap In" className="wall-logo" draggable="false" />
        </div>
        <h1 className="wall-title" data-testid="coming-soon-title">Coming Soon</h1>

        {showCode ? (
          <form onSubmit={submitCode} className="wall-code-form" data-testid="access-code-form">
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Enter access code"
              autoFocus
              className="wall-input"
              data-testid="access-code-input"
              aria-label="Access code"
            />
            <button
              type="submit"
              className="wall-send"
              disabled={codeBusy}
              data-testid="access-code-submit"
              aria-label="Unlock the site"
            >
              {codeBusy ? "…" : <KeyRound size={17} />}
            </button>
          </form>
        ) : (
          <button
            type="button"
            className="wall-code-link"
            data-testid="access-code-link"
            onClick={() => setShowCode(true)}
          >
            Have an access code?
          </button>
        )}
        {codeMsg && (
          <p className={`wall-note ${codeMsg.ok ? "text-ok" : "text-err"}`} data-testid="code-message">
            {codeMsg.text}
          </p>
        )}

        <p className="wall-sub" data-testid="waitlist-prompt">Be the first to know when we go live!</p>
        {wlState === "done" ? (
          <p className="wall-note text-ok" data-testid="waitlist-success">{wlMsg}</p>
        ) : (
          <form onSubmit={submitWaitlist} className="wall-waitlist-form" data-testid="waitlist-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="wall-input"
              data-testid="waitlist-email-input"
              aria-label="Email for the waitlist"
            />
            <button
              type="submit"
              className="wall-send"
              disabled={wlState === "busy"}
              data-testid="waitlist-submit"
              aria-label="Join the waitlist"
            >
              <Mail size={17} />
            </button>
          </form>
        )}
        {wlState === "error" && (
          <p className="wall-note text-err" data-testid="waitlist-error">{wlMsg}</p>
        )}
      </main>
      <footer className="wall-footer" data-testid="wall-footer">© 2026 Tap In. All rights reserved.</footer>
    </div>
  );
}